import { render, staticRenderFns } from "./DefaultFailure.vue?vue&type=template&id=48899d8c&scoped=true"
import script from "./DefaultFailure.vue?vue&type=script&lang=js"
export * from "./DefaultFailure.vue?vue&type=script&lang=js"
import style0 from "./DefaultFailure.vue?vue&type=style&index=0&id=48899d8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48899d8c",
  null
  
)

export default component.exports